import { Select } from 'antd';
import { useState, useEffect } from 'react';

const { Option } = Select;
const CODFilter = (props) => {

    const [selectedOptions, setSelectedOptions] = useState([]);

    useEffect(() => {
        setSelectedOptions(["กลุ่มโรคติดเชื้อ, ความผิดปกติในมารดาและปริกำเนิด และ ภาวะโภชนาการบกพร่อง"]);
      }, []);

    const cod_arr = [
        "กลุ่มโรคติดเชื้อ, ความผิดปกติในมารดาและปริกำเนิด และ ภาวะโภชนาการบกพร่อง", "โรคไม่ติดต่อ",
        "การบาดเจ็บ", "ไม่ทราบสาเหตุการตาย",
    ];

    const children = [];
    for (let i = 0; i < cod_arr.length; i++) {
    children.push(<Option style = {{ color: '#70ad47', fontFamily: 'Helvetica' }} key={cod_arr[i]}>{cod_arr[i]}</Option>);
    }

    function handleChange(value) {
        setSelectedOptions(value);
    }

    props.onChange(selectedOptions);
    // props.onChange(selectedOptions);

    return ( 
        <div>
            <Select
                mode="multiple"
                allowClear
                style={{ width: 154, fontSize: '15px'}}
                placeholder="เลือก หรือ ค้นหา"
                defaultValue={["กลุ่มโรคติดเชื้อ, ความผิดปกติในมารดาและปริกำเนิด และ ภาวะโภชนาการบกพร่อง"]}
                onChange={handleChange}
                dropdownMatchSelectWidth={false}
            >
                {children}
            </Select>
        </div>
       
     );
}
 
export default CODFilter;